import {event} from "d3-selection";

export function nopropagation() {
  event.stopImmediatePropagation();
}

export default function() {
  event.preventDefault();
  event.stopImmediatePropagation();
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-drag/src/noevent.js
// module id = ../../../../d3-drag/src/noevent.js
// module chunks = 4